import * as React from 'react';
import * as lessons from "./style.module.scss";
export const Lessons = () => {
  return (
    <section className={lessons.lessons}>
      <div className={'container'}>
        <ul className={lessons.lessons__list}>
          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-01.png"
                alt={'Занятие 1'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={`${lessons.lessons__text} ${lessons.lessons__textBold} ${lessons.lessons__textMargin}`}>
                Поставите цель и&nbsp;сформируете маршрут изучения языка.
              </p>
              <p className={lessons.lessons__text}>
                Научитесь подробно планировать программу самостоятельного изучения иностранного языка.
              </p>
            </div>
          </li>

          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-02.png"
                alt={'Занятие 2'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={`${lessons.lessons__text} ${lessons.lessons__textBold} ${lessons.lessons__textMargin}`}>
                Получите алгоритм отработки фонетики и&nbsp;запоминания транскрипций.
              </p>
              <p className={lessons.lessons__text}>
                Сможете самостоятельно изучать фонетику любого языка, а&nbsp;также научитесь читать.
              </p>
            </div>
          </li>

          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-03.png"
                alt={'Занятие 3'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={lessons.lessons__text}>
                <span className={lessons.lessons__textBold}>
                  Освоите технику запоминания 100 иностранных слов за&nbsp;1&nbsp;час
                </span>{' '}
                и&nbsp;отработаете ее&nbsp;на&nbsp;практике, выучив более 2&nbsp;000 слов за&nbsp;весь тренинг.
              </p>
            </div>
          </li>

          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-04.png"
                alt={'Занятие 4'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={`${lessons.lessons__text} ${lessons.lessons__textBold}`}>
                Сможете с&nbsp;легкостью запоминать абстрактные слова, глаголы, наречия и&nbsp;прилагательные.
              </p>
            </div>
          </li>

          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-05.png"
                alt={'Занятие 5'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={`${lessons.lessons__text} ${lessons.lessons__textBold}`}>
                Научитесь сохранять новую информацию в&nbsp;долговременной памяти и&nbsp;правильно повторять&nbsp;ее.
              </p>
            </div>
          </li>

          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-06.png"
                alt={'Занятие 6'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={`${lessons.lessons__text} ${lessons.lessons__textBold} ${lessons.lessons__textMargin}`}>
                Составите майнд-карты для изучения грамматики, а&nbsp;также освоите паттерны для постановки навыка
                разговора.
              </p>
              <p className={lessons.lessons__text}>
                Выведите слова и&nbsp;грамматику в&nbsp;разговорный навык (с&nbsp;помощью паттернов со&nbsp;скоростью
                1500-2000 фраз в&nbsp;час).
              </p>
            </div>
          </li>

          <li className={lessons.lessons__item}>
            <div className={lessons.lessons__imgCover}>
              <img
                src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/zanyatie-07.png"
                alt={'Занятие 7'}
              />
            </div>
            <div className={lessons.lessons__descr}>
              <p className={`${lessons.lessons__text} ${lessons.lessons__textBold} ${lessons.lessons__textMargin}`}>
                Освоите навык письма и&nbsp;понимания на&nbsp;слух.
              </p>
              <p className={lessons.lessons__text}>
                Устраните раз и&nbsp;навсегда все ошибки в&nbsp;произношении и&nbsp;написании слов.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};
